// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1FWQi","head":"Table_head__3yVLa","col":"Table_col__3UcQG"};